'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, TextPassage } from '@petsmart-ui/sparky';
import Link from 'next/link';
import { NEW_TAB, SECONDARY_BUTTON_STYLE, TARGET_BLANK, TARGET_SELF } from '../../../../constants';
import { ColoredTextLink } from '../../../ColoredTextLink';
import type { StoreCardData } from '../types';
import './styles.scss';
export function FaqStoreCard(t0) {
  const $ = _c(22);
  const {
    cityState,
    address,
    badges,
    phoneNumber,
    cta
  } = t0;
  const cityStateHref = cityState.link?.webUrl ?? "";
  const ctaHref = cta?.link?.webUrl ?? "";
  const ctaTarget = cta?.behavior === NEW_TAB ? TARGET_BLANK : TARGET_SELF;
  let t1;
  if ($[0] !== cityState.actionText || $[1] !== cityStateHref) {
    t1 = <ColoredTextLink className="faq-store-card__headline" href={cityStateHref} color="Dark Grey">{cityState.actionText}</ColoredTextLink>;
    $[0] = cityState.actionText;
    $[1] = cityStateHref;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== address) {
    t2 = <TextPassage>{address}</TextPassage>;
    $[3] = address;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `tel:${phoneNumber}`;
  let t4;
  if ($[5] !== phoneNumber || $[6] !== t3) {
    t4 = <ColoredTextLink href={t3} color="Dark Grey">{phoneNumber}</ColoredTextLink>;
    $[5] = phoneNumber;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="faq-store-card__text">{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== badges) {
    t6 = badges?.length ? <div className="faq-store-card__badges">{badges.map(_temp)}</div> : null;
    $[11] = badges;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== cta || $[14] !== ctaHref || $[15] !== ctaTarget) {
    t7 = cta && <Link prefetch={false} href={ctaHref} target={ctaTarget} rel="noopener noreferrer"><Button variant={SECONDARY_BUTTON_STYLE} text={cta.text} size="sm" /></Link>;
    $[13] = cta;
    $[14] = ctaHref;
    $[15] = ctaTarget;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t1 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <div className="faq-store-card">{t1}{t5}{t6}{t7}</div>;
    $[17] = t1;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}
function _temp(t0, index) {
  const {
    text
  } = t0;
  return <TextPassage className="faq-store-card__badge" size="sm" key={`${text}-${index}`}>{text}</TextPassage>;
}